import * as Yup from 'yup'

export const validationSchema = ({ requireGanttProPrefix = false } = {}) =>
  Yup.object({
    link: Yup.string()
      .trim()
      .url('Введите корректную ссылку.')
      .when([], (schema) => {
        if (!requireGanttProPrefix) return schema

        return schema.test(
          'ganttpro-prefix',
          'Значение поля ссылки на план-график проекта некорректно',
          (value) => {
            if (!value) return true
            return value.startsWith('https://app.ganttpro.com')
          }
        )
      }),
    isProtected: Yup.boolean().notRequired(),
  })
